import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    // "modal",
    // "promoteButton",
    // "recipientCheckbox",
    // "sendNotificationButton",
    // "viewButton",
    // "notificationRecipients",
    "saveButton",
  ];
  static values = {
    template: String,
  };

  connect() {
    // console.log("Hello, Stories Interview Template Tag Controller here!", this.element);
  }

  addTag(event) {
    event.preventDefault();
    fetch(`/interview_templates/${this.templateValue}/tags/new`, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    })
      .then((response) => {
        if (!response.ok) throw new Error(response.statusText);
        return response.text();
      })
      .then((html) => Turbo.renderStreamMessage(html));
  }

  submitTagForm(event) {
    event.preventDefault();
    const form = document.getElementById(event.params.formId);
    if (form) form.requestSubmit();
  }

  markResponsesTableAsReloadable(event) {
    if (event.detail && !event.detail.success) return;

    document.querySelector("#responses-table")?.setAttribute("reloadcontent", "true");
  }

  cancelNewRow(event) {
    event.preventDefault();
    const row = event.target.closest("tr");
    if (row) row.outerHTML = '<tr id="new-tag-form"></tr>';
  }
}
